<template>
  <view class="package-item">
    <view class="package-item-desc">
      <view class="package-item-desc-skechy">
        <view class="package-item-desc-skechy-num">{{ packageInfo.amount }}</view>
        <view class="package-item-desc-skechy-unit">个</view>
      </view>
      <view class="package-item-desc-detail">
        <view class="package-item-desc-detail-top">
          {{ packageInfo.name }}
        </view>
        <view class="package-item-desc-detail-bot">
          {{ packageInfo.remark }}
        </view>
      </view>
    </view>
    <view class="package-item-btn-wrapper" bindtap="share">
      <view class="package-item-btn" wx:class="{{!isStock && 'share'}}" wx:if="{{!isHarmonyos}}"> {{ btnText }}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { invokeShare, xenv, canIUse, is } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import store from '@/store'
  import { HOME_SHARE_ID } from '@/config/falling-popup/constant'

  createComponent({
    props: {
      packageItem: {
        type: Object,
        value: ()=>{}
      },
      // 是否为已领取加速包
      isStock: {
        type: Boolean,
        value: false
      },
      posterUrl: {
        type: String,
        value: ''
      }
    },
    computed: {
      isHarmonyos() {
        return is('harmonyos')
      },
      packageInfo() {
        return this.packageItem?.package_info ?? {}
      },
      btnText() {
        return this.isStock ? '已领取' : '去分享'
      }
    },
    methods: {
      ...store.mapMutations({
        setRequestForHomeHide: 'common.setRequestForHomeHide'
      }),
      share() {
        if(this.isStock) return
        if(is('alipay'))  return mpx.showToast({
          title: '当前环境不支持分享活动', 
          icon: 'error', 
          duration: 2000, 
        });
        trackEvent('userteam_train_homecoupon_float_share_ck', 'UT-火车票-首页领券组件浮层-加速包分享-点击', {})
        const option = {
          title: "用滴滴火车票，享大额优惠券", // H5-主标题
          img_url: "https://ut-static.udache.com/webx/sfc/GMumI7gSQZiPWPaz8efIf.png", // 微信小程序卡片-图片
          card_content: "用滴滴火车票，享大额优惠券", // 微信小程序卡片-标题
          icon: "http://dpubstatic.udache.com/static/dpubimg/7a1b34f8-495b-4c8e-8637-c10d9b8176ca.png", // H5-小图标
          poster_url: this.posterUrl,
          channels: {
            wx_appmsg: [ // 分享给微信好友
              {
                xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
                share_type: "miniApp", // 分享类型
                appid: "gh_7a5c4141778f", // 分享出的小程序AppId
                miniprogram_type: 0,
                path: "/pages/index/index?dchn=nPdgL5G"
              },
            ],
            wx_timeline: [ // 分享到微信朋友圈
              {
                xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
                share_type: "image", // 分享类型
              }
            ],
          },
          mpShareConfig: {
            share_title: '求助好友为你加速',
            poster_title: '海报已保存到本地相册', 
            poster_sub_title: '去朋友圈分享海报求助力吧'
          },
          activity_id: HOME_SHARE_ID,
        }
        canIUse('invokeShare') && invokeShare(option)
        this.setRequestForHomeHide(true)
      },
      
    }
  })
</script>

<style scoped lang="stylus">
  .package-item
    height 82px
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    background #FFF7E6
    border-radius 10px
    border 0.75px solid rgba(255, 89, 0, 0.19)
    margin-bottom 10px
    &-desc
      display flex
      &-skechy
        width 90px
        display flex
        justify-content center
        align-items baseline
        letter-spacing 0px
        color #F86316
        &-num
          font-family Barlow Semi Condensed
          font-size 35px
          font-weight 400
          line-height 35px
        &-unit
          font-size 14px
          font-weight 600
          line-height 15px
          font-family PingFangSC-Semibold
      &-detail
        display flex
        flex-direction column
        letter-spacing 0px
        &-top
          font-size 15px
          line-height 15px
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 8px
        &-bot
          font-family PingFangSC-Regular
          font-weight 400
          font-size 10px
          line-height 10px
          color #B69786
    .package-item-btn-wrapper
      width 94px
      display flex
      justify-content center
      align-items center
      .package-item-btn
        display flex
        justify-content center
        align-items center
        font-family PingFangSC-Medium
        font-weight 500
        color rgba(248, 99, 22, 0.3)
        &.share
          padding 8px 12px
          border-radius 13.5px
          background linear-gradient(270deg, #FF4A4E 0%, #FF712E 100%)
          font-size 13px
          font-family PingFangSC-Medium
          font-weight 500
          line-height 11px
          letter-spacing 0px
          color #FFFFFF
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {}
    }
</script>